import React, { useEffect } from 'react';
import Portal from '../Portal';

interface PaymentFailureModalProps {
  onClose: () => void;
}

export function PaymentFailureModal({ onClose }: PaymentFailureModalProps) {
  // Lock body scroll when modal is open
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleTryAgain = () => {
    // Refresh the current page, keeping the user on /upgrade
    window.location.reload();
  };

  return (
    <Portal>
      <div
        className="fixed inset-0 bg-black/80 backdrop-blur-sm z-[9999] flex items-center justify-center p-4"
        onClick={handleBackdropClick}
      >
        <div className="bg-bg border border-white/20 rounded-xl p-6 sm:p-8 w-full max-w-md shadow-lg">
          <div className="mb-6">
            <h2 className="text-2xl font-bold text-white text-center">
              Payment Failed
            </h2>
          </div>

          <div className="mb-8">
            <p className="text-white/90 text-lg text-center">
              Whoops, looks like your payment failed! Please try again or use a different payment method.
            </p>
          </div>

          <button
            onClick={handleTryAgain}
            className="w-full bg-[#F9F7EA] text-[#0f1218] px-6 py-3 min-h-[48px] rounded-full text-base font-semibold hover:bg-[#E7D7B1] transition-colors"
          >
            Try Again
          </button>
        </div>
      </div>
    </Portal>
  );
}

